import { isPlatformBrowser } from '@angular/common';
import {
 Component,
 OnInit,
 signal,
 Inject,
 PLATFORM_ID,
 inject,
 ChangeDetectorRef,
 afterNextRender,
 effect,
 WritableSignal,
} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { WebengageService } from '@core/services/webengage.service';
import { NotificationService } from '@shared/components/notification/notification.service';
import { WINDOW } from './app.module';
import { MatDialog } from '@angular/material/dialog';
import { PosthogService } from '@shared/services/posthog.service';
import { filter } from 'rxjs';
import { AutocompleteService } from '@shared/services/autocomplete.service';
import { DatepickerService } from '@shared/services/datepicker.service';
import { SearchBoxService } from '@shared/services/serach-box.service';
import { PageScrollLockService } from '@shared/services/page-scroll-lock.service';

@Component({
 selector: 'iho-root',
 templateUrl: './app.component.html',
 styleUrls: ['./app.component.scss'],
 providers: [],
})
export class AppComponent implements OnInit {
 title = 'ihowebsite';
 counter = 1;
 posthogService = inject(PosthogService);
 showPWA = false;
 showInstallGuide = false;
 dialog = inject(MatDialog);
 autocompleteService = inject(AutocompleteService);
 datepickerService = inject(DatepickerService);
 searchBoxService = inject(SearchBoxService);
 pageScrollLock = inject(PageScrollLockService);
 isMobile(): boolean {
  if (!isPlatformBrowser(this.platformId)) return false;

  const userAgent = window.navigator.userAgent || window.navigator.vendor || (window as any).opera;
  return /iPhone|iPad|iPod|android/i.test(userAgent);
 }
 deferredPrompt: any = null;
 notification = inject(NotificationService);
 cdr = inject(ChangeDetectorRef);
 route = inject(Router);
 router = inject(ActivatedRoute);
 navigatorVal: any = isPlatformBrowser(this.platformId)
  ? /Android|iPhone/.test(this.window.navigator.userAgent)
  : undefined;
 isShowSliderCity: WritableSignal<boolean> = signal(false);
 constructor(
  private webengage: WebengageService,
  @Inject(PLATFORM_ID) private platformId: Object,
  @Inject(WINDOW) public window: Window
 ) {
  effect(() => {
   this.syncPageScrollLock(
    'mobile-autocomplete',
    this.autocompleteService._isMobile() && this.autocompleteService._state() !== 'hide'
   );
  });
  effect(() => {
   this.syncPageScrollLock(
    'mobile-datepicker',
    this.datepickerService._isMobile() && this.datepickerService._state()
   );
  });
  effect(() => {
   this.syncPageScrollLock(
    'mobile-search-dialog',
    this.searchBoxService.toggleMobileSearchBox()
   );
  });

  afterNextRender(() => {
   window.addEventListener('raychat_ready', function (ets) {
    if (/Android|iPhone/.test(window.navigator.userAgent)) {
     (window as any).Raychat.setStyle({
      width: '0px !important',
      height: '0px !important',
      pointerEvents: 'none',
      shadowBox: '0 0 0 0 white !important',
     });
     (window as any).Raychat.setPosition({
      bottom: '-100%',
      right: '-100%',
     });
    } else {
     (window as any).Raychat.setStyle({
      zIndex: '9 !important',
      borderRadius: '100%',
     });
    }
   });
  });
 }

 CsrStatus = signal(false);

 ngOnInit(): void {
  this.route.events
   .pipe(filter((event: any) => event instanceof NavigationEnd))
   .subscribe((event: NavigationEnd) => {
    this.autocompleteService.setState('hide');
    this.datepickerService.setState(false);
    this.searchBoxService.toggleMobileSearchBox.set(false);
    this.pageScrollLock.clear();

    const url = event.urlAfterRedirects || event.url;
    const segments = url.split('/').filter(Boolean);
    this.isShowSliderCity.set(['city', 'district'].includes(segments[1]) ? false : true);
   });
  if (isPlatformBrowser(this.platformId)) {
   window.addEventListener('offline', () => {
    this.notification.warning('آفلاین', 'ارتباط با اینترنت برقرار نیست', 3000);
   });

   window.addEventListener('online', () => {
    this.notification.success('آنلاین', 'ارتباط برقرار شد، لطفا صفحه را مجدد بارگزاری کنید', 3000);
   });

   if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
    navigator.serviceWorker.register('/custom-sw.js');
   }

   const wasPromptShown = localStorage.getItem('pwa-install-dismissed');
   if (!wasPromptShown && this.isMobile()) {
    setTimeout(() => {
     window.addEventListener('beforeinstallprompt', (e: any) => {
      e.preventDefault();
      this.deferredPrompt = e;
      this.showPWA = true;
     });
    }, 1000);

    if (this.isIOS() && !this.isInStandaloneMode()) {
     this.showInstallGuide = true;
    }
   }

   setTimeout(() => {
    const notFoundEl = document.querySelector('.not-found');
    if (notFoundEl) {
     //  document.querySelector('.cdk-overlay-container')?.remove();
     this.dialog.closeAll();
    }
   }, 1);
  }

//   this.posthogService.init();
//   setTimeout(() => {
//    const data = {
//     name: 'Alireza',
//     family: 'Parastar',
//     time: new Date(),
//    };
//    this.posthogService.sendEvent('test', data);
//   }, 5000);
 }

 private syncPageScrollLock(token: string, shouldLock: boolean): void {
  const isMobileViewport = isPlatformBrowser(this.platformId) && this.window.innerWidth < 1024;
  if (shouldLock && isMobileViewport) {
   this.pageScrollLock.lock(token);
  } else {
   this.pageScrollLock.unlock(token);
  }
 }

 dismissInstallPrompt(): void {
  this.showPWA = false;
  this.deferredPrompt = null;
  if (isPlatformBrowser(this.platformId)) {
   localStorage.setItem('pwa-install-dismissed', 'true'); // کاربر رد کرد
  }
 }

 installApp(): void {
  if (this.deferredPrompt) {
   this.deferredPrompt.prompt();
   this.deferredPrompt.userChoice.then(() => {
    if (isPlatformBrowser(this.platformId)) {
     localStorage.setItem('pwa-install-dismissed', 'true'); // دیگه نشون نده
    }
    this.deferredPrompt = null;
    this.showPWA = false;
   });
  }
 }
 isIOS(): boolean {
  const ua = this.window.navigator.userAgent;
  return /iPhone|iPad|iPod/.test(ua);
 }

 isInStandaloneMode(): boolean {
  return 'standalone' in this.window.navigator && (this.window.navigator as any).standalone;
 }

 dismissGuide() {
  this.showInstallGuide = false;
  if (isPlatformBrowser(this.platformId)) {
   localStorage.setItem('pwa-install-dismissed', 'true'); // کاربر رد کرد
  }
 }
}
